<form [formGroup]="dummyForm">
  <ng-container *ngIf="widget.widgetConfig && widget.widgetConfig.matUiType">
    <!-- textbox  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.textbox"
      (click)="onClick(widget.widgetId, widget)">

      <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100 rounded-0 mat-no-hint">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input [type]="widget.widgetConfig.type" matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
      </mat-form-field>
    </div>

    <!-- drop down  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.dropdown"
      (click)="onClick(widget.widgetId, widget)" [ngStyle]="widget.widgetConfig?.style">
      <mat-form-field class="w-100 rounded-0 mat-no-hint" [appearance]="widget.widgetConfig.matUiType">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <mat-select [required]="isRequired(widget.widgetConfig?.validations)"
          [placeholder]="widget.widgetConfig.placeholderText" [multiple]="widget.widgetConfig?.type !== 'SingleSelect'">
          <mat-option *ngFor="let item of widget.widgetDataSource.datasource" [value]="item.label">{{item.label}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- radio button  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.radio" (click)="onClick(widget.widgetId, widget)"
      [ngStyle]="widget.widgetConfig?.style">
      <label class="mb-form-label" [style.font-family]="selectedHeadFontFamily"
        [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}<span
          class="error-message" *ngIf="isRequired(widget.widgetConfig?.validations)">*</span></label>
      <mat-radio-group aria-label="Select an option" class="d-flex flex-column gap-1">
        <mat-radio-button class="ms-0" [id]="item.label" [name]="item.label" [value]="item.label"
          *ngFor="let item of widget.widgetDataSource.datasource">{{item.label}}</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- checkbox -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.singleselectcheckbox"
      (click)="onClick(widget.widgetId,widget)" [ngStyle]="widget.widgetConfig?.style">
      <mat-checkbox class="d-flex align-items-center mat-radio-check-button"> {{widget.widgetLabel}}</mat-checkbox>
    </div>

    <!-- button  -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.button"
      (click)="onClick(widget.widgetId, widget)">
      <ng-container *ngIf="widget.widgetConfig.matUiType == matUiTypes.outlined"><button
          mat-stroked-button class="w-100" >{{widget.widgetLabel}}</button></ng-container>
      <ng-container *ngIf="widget.widgetConfig.matUiType == matUiTypes.filled"><button
          mat-flat-button class="w-100">{{widget.widgetLabel}}</button></ng-container>
    </div>

    <!-- file picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.filePicker"
      (click)="onClick(widget.widgetId, widget)" [ngStyle]="widget.widgetConfig?.style">
      <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input  matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
        <mat-icon matSuffix>attach_file_add</mat-icon>
      </mat-form-field>
    </div>

    <!-- image picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.image" (click)="onClick(widget.widgetId, widget)"
      [ngStyle]="widget.widgetConfig?.style">
      <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100 rounded-0 mat-no-hint">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input [type]="widget.widgetConfig.type" matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
          <mat-icon matSuffix>add_photo_alternate</mat-icon>
      </mat-form-field>
    </div>

    <!-- date picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.date" (click)="onClick(widget.widgetId, widget)">
      <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100 rounded-0 mat-no-hint">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input [type]="widget.widgetConfig.type" matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
          <mat-icon matSuffix>calendar_month</mat-icon>
      </mat-form-field>
    </div>

    <!-- text  -->
    <ng-container *ngIf="widget.widgetType == widgetTypes.plainText">
      <div class="mb-form-group m2" (click)="onClick(widget.widgetId, widget)">
        <div class="mb-form-title-text" style="border: 0; overflow: auto; word-wrap: break-word">
          <h2 [style.font-family]="selectedBodyFamily" [style.color]="widget.widgetConfig?.style?.color"
            [style.font-style]="widget.widgetConfig?.style['font-style']"
            [style.font-size]="widget.widgetConfig?.style['font-size']"
            [style.font-weight]="widget.widgetConfig?.style['font-weight']"
            [style.width]="widget.widgetConfig?.style['width']" [style.width]="widget.widgetConfig?.style['height']"
            [style.text-decoration]="
            widget.widgetConfig?.style['text-decoration']
          " >
            {{ widget.widgetLabel }}
          </h2>
        </div>
      </div>
    </ng-container>

    <!-- navgation heading in progress  -->
    <div *ngIf="widget.widgetType == widgetTypes.navText" [ngStyle]="widget.widgetConfig?.style"
      (click)="onClick(widget.widgetId, widget)">
      <h3 [style.font-family]="selectedHeadFontFamily">
        {{ widget.widgetLabel }}
      </h3>
    </div>

    <!-- navgation button in progress  -->
    <div *ngIf="widget.widgetType == widgetTypes.navButton" class="d-flex justify-content-space-between"
      [ngStyle]="widget.widgetConfig?.style" (click)="onClick(widget.widgetId, widget)">
      <button mat-icon-button [type]="widget.type || 'button'">
        <mat-icon>{{ widget?.widgetConfig?.image || "" }}</mat-icon>
      </button>
    </div>

    <!-- image uploader -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.imageUploader"
      [ngStyle]="widget?.widgetConfig?.style" style="width: 100%; height: 100%"
      (click)="onClick(widget.widgetId, widget)">
      <div [ngClass]="{ 'login-image': page.pageType === pageTypes.loginPage }"
        style="width: 100%; height: 100%; overflow: hidden">
        <img [src]="getImageFile(widget.widgetConfig.image)" style="width: 100%; height: 100%; display: block" />
      </div>
    </div>

    <!-- faceId -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.faceId"
      (click)="onClick(widget.widgetId, widget)" [ngStyle]="widget.widgetConfig?.style">
      <div class="image">
        <img src="../assets/images/face-id.svg" class="biometric" />
      </div>
    </div>

    <!-- fingerprint -->
    <ng-container *ngIf="widget.widgetType == widgetTypes.fingerPrint">
      <div class="mb-form-group style-none" *ngIf="widget.widgetConfig?.enable"
        (click)="onClick(widget.widgetId, widget)" [ngStyle]="widget.widgetConfig?.style">
        <div class="image">
          <img src="../assets/images/biometric.svg" class="biometric" />
        </div>
      </div>
    </ng-container>

    <!-- separator -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.separator"
      (click)="onClick(widget.widgetId, widget)">
      <!-- <hr style="opacity: 1;" [ngStyle]="widget.widgetConfig?.style" > -->
      <md-divider [ngStyle]="{
        '--md-divider-thickness': widget.widgetConfig?.style['size'],
        '--md-divider-color': widget.widgetConfig?.style?.color
      }"></md-divider>
    </div>

    <div class="scanner mb-form-group" *ngIf="widget.widgetType == widgetTypes.scanner"
      [ngStyle]="widget.widgetConfig?.style" (click)="onClick(widget.widgetId, widget)">
      <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100 rounded-0 mat-no-hint">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input  matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
          <mat-icon matSuffix><span class="mdi mdi-line-scan"></span></mat-icon>
      </mat-form-field>
    </div>


    <!-- address  -->
    <div class="scanner mb-form-group" *ngIf="widget.widgetType == widgetTypes.address" [ngStyle]="
      widget.widgetId == widgetId
        ? textColor != ''
          ? { color: textColor }
          : widget.widgetConfig?.style
        : widget.widgetConfig?.style
    " (click)="onClick(widget.widgetId, widget)">
       <mat-form-field [appearance]="widget.widgetConfig.matUiType" class="w-100 rounded-0 mat-no-hint">
        <mat-label>{{widget.widgetLabel}}</mat-label>
        <input  matInput formControlName="dummy" autocomplete="off"
          [style.font-style]="widget.widgetConfig?.style['font-style']">
          <mat-icon matSuffix>location_on</mat-icon>
      </mat-form-field>
    </div>

    <!-- geotag -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.geotag" [ngStyle]="widget.widgetConfig?.style"
      (click)="onClick(widget.widgetId, widget)">
      <div class="input-wrapper">
        <label class="mb-form-control" [style.color]="widget.widgetConfig?.style?.color"
          [style.font-family]="selectedBodyFamily">{{ widget.widgetLabel }}
          <span *ngIf="isRequired(widget.widgetConfig?.validations)">*</span></label>
        <div class="image-container">
          <img src="../assets/images/geotag.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>

    <!-- dataList -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.datalist" [ngStyle]="widget.widgetConfig?.style"
      (click)="onClick(widget.widgetId, widget)">
      <mat-card [ngStyle]="widget.widgetConfig?.style" [style.font-family]="selectedBodyFamily">
        <mat-card-content>
          <div class="d-flex justify-content-between gap-3">
            <div class="flex-fill mb-text-value w-50">
              <span class="text-ellipsis text-word-break" *ngFor="
                let item of widget.widgetConfig?.dataListWidgetConfig?.lhsItems
              ">{{ item.widgetLabel }}</span>
            </div>

            <div class="mb-text-value text-right w-50">
              <span class="text-ellipsis text-word-break" *ngFor="
                let item of widget.widgetConfig?.dataListWidgetConfig?.rhsItems
              ">{{ item.widgetLabel }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Display Widgets -->
    <div *ngIf="displayWidgetCharts.includes(widget.widgetType)" class="w-100 h-100"
      (click)="onClick(widget.widgetId, widget)">
      <vl-highcharts-renderer [height]="gridItemHeigthWidth.height" [width]="gridItemHeigthWidth.width"
        [widgetType]="widget.widgetType" [widgetConfig]="widget.widgetConfig"
        [widgetData]="widget"></vl-highcharts-renderer>
    </div>

    <div *ngIf="widget.widgetType == widgetTypes.map" style="width: 350px; height: 350px"
      (click)="onClick(widget.widgetId, widget)">
      <div id="{{widget.widgetId + '_map'}}" style="height: 100%;">
      </div>
    </div>

    <div *ngIf="widget.widgetType == widgetTypes.table" (click)="onClick(widget.widgetId, widget)">
      <label for="">{{ widget.widgetConfig?.tableConfig ? widget.widgetConfig?.tableConfig.title : 'Heading' }}</label>
      <lib-data-table tableType="dataTable" class="w-100 h-100" tableId=customerlist [tableConfig]="tableConfig"
        [data]="tableData" (optionsClick)="handleOptionClick($event)" [clickableDataTypes]="dataTypes">
      </lib-data-table>
    </div>

  </ng-container>
</form>